// Presenter Archetype — versioned local-progress persistence (brief §7).
// Wrapped in try/catch throughout: Safari private mode / disabled storage
// must never break the assessment — it just runs in-memory only, and the
// caller shows `ui.storageUnavailable` once when a save attempt fails.

const STORAGE_KEY = "interact-presenter-archetype-progress-v1";

export const loadProgress = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== "object" || !Array.isArray(data.answers) || data.answers.length !== 7) {
      return null;
    }
    return data;
  } catch {
    return null;
  }
};

// Returns true on success, false if storage is unavailable/full.
export const saveProgress = (data) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...data, savedAt: Date.now() }));
    return true;
  } catch {
    return false;
  }
};

export const clearProgress = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* no-op — nothing to clear if storage never worked */
  }
};
